// extracted by mini-css-extract-plugin
export default {"cls1":"qQ5mKkleyJCe4RMVtHo_","cls2":"Fl6Oqme3p28zcX2P7YGX qQ5mKkleyJCe4RMVtHo_"};